export default {
	buildings: {
		buildingCount: 'Anzahl Gebäude',
		doorwayCount: 'Anzahl Eingänge',
		assignTeamMember: 'Teammitglied hinterlegen',
		editTeamMember: 'Teammitglied bearbeiten',
		removeTeamMember: 'Teammitglied entfernen',
		confirmRemoveTeamMember:
			'Möchten Sie die Teammitglied-Zuordnung von dieser Liegenschaft entfernen?',
		teamMemberRemovedSuccess: 'Teammitglied wurde erfolgreich entfernt',
		teamMemberRemoveError:
			'Fehler beim Entfernen des Teammitglieds. Bitte versuchen Sie es erneut.',
		setAsTitleImage: 'Als Titelbild festlegen',
		addImage: 'Bild hinzufügen',
		deleteImage: 'Bild löschen',
		general: 'Generell',
		uploadImage: 'Bild hinterlegen',
		// Property Manager Assignment
		propertyManager: 'Hausverwalter',
		propertyManagerModalTitle: 'Hausverwalter zuweisen',
		selectedBuildingsCount:
			'{count} Liegenschaft ausgewählt | {count} Liegenschaften ausgewählt',
		selectPropertyManager: 'Hausverwalter auswählen',
		assignPropertyManager: 'Zuweisen',
		removePropertyManager: 'Entfernen',
		markForExportCheckbox: 'Gleichzeitig für Aaremo freigeben',
		markForExportCheckboxHint:
			'Wenn aktiviert, werden die Liegenschaften automatisch für den Export nach Aaremo freigegeben',
		assignPropertyManagerTitle: 'Hausverwalter zuweisen',
		removePropertyManagerTitle: 'Hausverwalter entfernen',
		assignPropertyManagerDescription:
			'Sie sind dabei, "{name}" als Hausverwalter für {count} Liegenschaft zuzuweisen. | Sie sind dabei, "{name}" als Hausverwalter für {count} Liegenschaften zuzuweisen.',
		removePropertyManagerDescription:
			'Sie sind dabei, den Hausverwalter von {count} Liegenschaft zu entfernen. | Sie sind dabei, den Hausverwalter von {count} Liegenschaften zu entfernen.',
		assignPropertyManagerDisclaimer:
			'Das Zuweisen eines Hausverwalters aktualisiert alle ausgewählten Liegenschaften. Der Hausverwalter ist für Anfragen und Bearbeitung zuständig. Wenn eine Liegenschaft für Aaremo freigegeben ist, wird sie synchronisiert.',
		removePropertyManagerDisclaimer:
			'⚠️ WARNUNG: Das Entfernen des Hausverwalters verhindert die Freigabe von Liegenschaften für Aaremo. Bei aktuell freigegebenen Liegenschaften wird die Freigabe automatisch zurückgenommen.',
		confirmAssign: 'Bestätigen & Zuweisen',
		confirmRemove: 'Bestätigen & Entfernen',
		propertyManagerUpdateError:
			'Fehler beim Aktualisieren des Hausverwalters. Bitte versuchen Sie es erneut.',
		confirmAssignPropertyManager:
			'Möchten Sie "{name}" als Hausverwalter für {count} Liegenschaft zuweisen? | Möchten Sie "{name}" als Hausverwalter für {count} Liegenschaften zuweisen?',
		confirmRemovePropertyManager:
			'Möchten Sie den Hausverwalter von {count} Liegenschaft entfernen? | Möchten Sie den Hausverwalter von {count} Liegenschaften entfernen?',
		// Export
		export: 'Export',
		exportFilter: {
			proposed: 'Freigegeben',
			not_proposed: 'Nicht freigegeben',
			missing_pm: 'Hausverwalter fehlt',
			all: 'Alle',
		},
		markForExport: 'Für Aaremo freigeben',
		unmarkForExport: 'Aus Aaremo entfernen',
		proposeForExport: 'Für Aaremo freigeben',
		confirmMarkForExport:
			'Möchten Sie {count} Liegenschaft für Aaremo freigeben? | Möchten Sie {count} Liegenschaften für Aaremo freigeben?',
		confirmUnmarkForExport:
			'Möchten Sie {count} Liegenschaft aus Aaremo entfernen? | Möchten Sie {count} Liegenschaften aus Aaremo entfernen?',
		confirmMarkSingleForExport:
			'Möchten Sie "{name}" für den Export nach Aaremo freigeben? Die Liegenschaft wird dann aus Karthago nach Aaremo übertragen.',
		confirmUnmarkSingleFromExport:
			'Möchten Sie "{name}" aus Aaremo entfernen? Die Liegenschaft wird dann nicht mehr aus Karthago nach Aaremo übertragen.',
		thisBuilding: 'diese Liegenschaft',
		// Export Status Modal
		markForExportTitle: 'Liegenschaft für Aaremo freigeben',
		unmarkFromExportTitle: 'Liegenschaft aus Aaremo entfernen',
		buildingLabel: 'Liegenschaft',
		markForExportDescription:
			'Sie sind dabei, diese Liegenschaft für den Export nach Aaremo freizugeben. Die Daten werden dann aus dem Karthago Immobilienverwaltungssystem nach Aaremo übertragen.',
		unmarkFromExportDescription:
			'Sie sind dabei, die Aaremo-Freigabe dieser Liegenschaft zurückzunehmen. Es werden dann keine Daten mehr aus Karthago nach Aaremo übertragen.',
		whatHappens: 'Was passiert als Nächstes?',
		whatHappensMarkItem1:
			'Die Liegenschaft wird als "für Aaremo freigegeben" markiert',
		whatHappensMarkItem2:
			'Alle Daten dieser Liegenschaft, einschließlich Adresse, Einheiten und Hausverwalter-Informationen, werden nach Aaremo übertragen',
		whatHappensMarkItem3:
			'Zukünftige Änderungen an dieser Liegenschaft werden automatisch aus Karthago nach Aaremo übertragen',
		whatHappensMarkItem4:
			'Der Synchronisierungsprozess kann einige Minuten in Anspruch nehmen',
		whatHappensUnmarkItem1:
			'Die Aaremo-Freigabe dieser Liegenschaft wird zurückgenommen',
		whatHappensUnmarkItem2:
			'Es werden keine weiteren Änderungen an dieser Liegenschaft aus Karthago nach Aaremo übertragen',
		whatHappensUnmarkItem3:
			'Alle zugehörigen Daten (Einheiten, Personen, usw.) werden bei der nächsten Synchronisierung aus Aaremo gelöscht',
		disclaimer: 'Wichtiger Hinweis',
		markForExportDisclaimer:
			'Bitte stellen Sie sicher, dass alle Liegenschaftsdaten vollständig und korrekt sind, bevor Sie sie für Aaremo freigeben. Unvollständige oder fehlerhafte Daten können zu Synchronisierungsfehlern führen.',
		unmarkFromExportDisclaimer:
			'⚠️ WARNUNG: Das Entfernen einer Liegenschaft aus Aaremo wird bei der nächsten Synchronisierung ALLE zugehörigen Daten (Liegenschaft, Einheiten, Personen, Verträge, usw.) aus Aaremo LÖSCHEN. Die Daten in Karthago bleiben erhalten, sind aber nicht mehr in der mobilen Plattform verfügbar. Diese Aktion kann nicht automatisch rückgängig gemacht werden.',
		hint: 'Tipp',
		exportStatusHint:
			'Sie können die Aaremo-Freigabe jederzeit über das Liegenschafts-Aktionsmenü ändern.',
		exportModalTitle: 'Aaremo-Freigabe',
		selectedBuildingsExportMessage:
			'{count} Liegenschaft ausgewählt | {count} Liegenschaften ausgewählt',
		exportModalDescription:
			'Geben Sie die ausgewählten Liegenschaften für Aaremo frei oder nehmen Sie die Freigabe zurück. Sie können Ihre Auswahl unten verfeinern.',
		currentExportStatus: 'Aktuelle Freigabe',
		proposed: 'Für Aaremo freigegeben',
		notProposed: 'Nicht freigegeben',
		propertyManagerRequired: 'Hausverwalter erforderlich',
		withPropertyManager: 'Mit Hausverwalter',
		withoutPropertyManager: 'Ohne Hausverwalter',
		propertyManagerStatus: 'Hausverwalter-Status',
		onlyBuildingsWithPMWillBeMarked:
			'Nur Liegenschaften mit Hausverwalter werden freigegeben',
		markBuildingsForExportTitle: 'Liegenschaften für Aaremo freigeben',
		unmarkBuildingsForExportTitle: 'Liegenschaften aus Aaremo entfernen',
		markBuildingsForExportDescription:
			'Sie sind dabei, {count} Liegenschaft für den Export nach Aaremo freizugeben. | Sie sind dabei, {count} Liegenschaften für den Export nach Aaremo freizugeben.',
		unmarkBuildingsForExportDescription:
			'Sie sind dabei, die Aaremo-Freigabe von {count} Liegenschaft zurückzunehmen. | Sie sind dabei, die Aaremo-Freigabe von {count} Liegenschaften zurückzunehmen.',
		markBuildingsForExportDisclaimer:
			'Bitte stellen Sie sicher, dass die Daten der ausgewählten Liegenschaften vollständig und korrekt sind, bevor Sie sie für Aaremo freigeben. Liegenschaften ohne Hausverwalter werden automatisch übersprungen.',
		unmarkBuildingsForExportDisclaimer:
			'⚠️ WARNUNG: Das Entfernen der ausgewählten Liegenschaften aus Aaremo wird bei der nächsten Synchronisierung ALLE zugehörigen Daten (Liegenschaft, Einheiten, Personen, Verträge, usw.) aus Aaremo LÖSCHEN. Die Daten in Karthago bleiben erhalten, sind aber nicht mehr in der mobilen Plattform verfügbar.',
		whatHappensMarkBuildingsItem1:
			'Die ausgewählten Liegenschaften werden als "für Aaremo freigegeben" markiert',
		whatHappensMarkBuildingsItem2:
			'Alle Daten dieser Liegenschaften werden aus Karthago nach Aaremo übertragen',
		whatHappensMarkBuildingsItem3:
			'Zukünftige Änderungen an diesen Liegenschaften werden automatisch aus Karthago nach Aaremo übertragen',
		whatHappensUnmarkBuildingsItem1:
			'Die Aaremo-Freigabe der ausgewählten Liegenschaften wird zurückgenommen',
		whatHappensUnmarkBuildingsItem2:
			'Es werden keine weiteren Änderungen an diesen Liegenschaften aus Karthago nach Aaremo übertragen',
		whatHappensUnmarkBuildingsItem3:
			'Alle zugehörigen Daten dieser Liegenschaften werden bei der nächsten Synchronisierung aus Aaremo gelöscht',
		noValidBuildingsForExport:
			'Keine gültigen Liegenschaften für die Freigabe (allen Liegenschaften fehlt ein Hausverwalter)',
		exportSuccessWithSkipped:
			'{updated} Liegenschaft(en) erfolgreich aktualisiert. {skipped} übersprungen (Hausverwalter fehlt).',
		// Security Verification
		securityVerification: 'Sicherheitsüberprüfung',
		enterPassword: 'Geben Sie Ihr Passwort ein',
		invalidPassword: 'Ungültiges Passwort. Bitte versuchen Sie es erneut.',
		disclaimerConfirmation:
			'Ich habe die Auswirkungen dieser Aktion gelesen und verstanden',
		confirmMark: 'Bestätigen & freigeben',
		confirmUnmark: 'Bestätigen & entfernen',
		markedForExportSuccess:
			'Liegenschaft wurde erfolgreich für Aaremo freigegeben',
		unmarkedFromExportSuccess:
			'Liegenschaft wurde erfolgreich aus Aaremo entfernt',
		exportStatusUpdateError:
			'Fehler beim Aktualisieren der Freigabe. Bitte versuchen Sie es erneut.',
		// Error messages
		errorMissingPropertyManager:
			'{count} Liegenschaft kann nicht freigegeben werden (Hausverwalter fehlt) | {count} Liegenschaften können nicht freigegeben werden (Hausverwalter fehlt)',
		exportRequiresPropertyManager:
			'Liegenschaft kann ohne Hausverwalter nicht freigegeben werden. Bitte zuerst einen Hausverwalter zuweisen.',
		partialExportSuccess:
			'{success} Liegenschaft(en) erfolgreich aktualisiert. {failed} fehlgeschlagen, da Hausverwalter fehlt.',
		// Status indicators
		exportMarked: 'Für Aaremo freigegeben',
		notProposedForExport: 'Nicht freigegeben',
		missingPropertyManager: 'Hausverwalter fehlt',
	},
}
